import React, { useState } from "react";
import TextField from "../../../bootstrap/TextField";
import {
  FirstNameAndNid,
  Passenger,
  Select,
  UserContactWrapper,
} from "./singleTravellerInformation.styles";

const SingleTravellerInformation = ({
  values,
  passengerIndex,
  handleChange,
  roundTrip,
}) => {
  const [contactError, setContactError] = useState('');
  const [idError, setIdError] = useState('');

  const validateContact = (value) => {
    // Only allow numeric values and exactly 10 digits
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length > 10) {
      setContactError('Contact number cannot exceed 10 digits');
      return false;
    } else if (numericValue.length > 0 && numericValue.length < 10) {
      setContactError('Contact number must be exactly 10 digits');
      return false;
    } else {
      setContactError('');
      return true;
    }
  };

  const validateIdNumber = (value) => {
    // Only allow numeric values
    const numericValue = value.replace(/\D/g, '');
    if (value !== numericValue) {
      setIdError('ID number must contain digits only');
      return false;
    } else {
      setIdError('');
      return true;
    }
  };

  const handleContactChange = (e) => {
    const value = e.target.value;
    // Remove any non-numeric characters and limit to 10 digits
    const numericValue = value.replace(/\D/g, '').slice(0, 10);
    validateContact(numericValue);
    
    // Create synthetic event with the cleaned value
    const syntheticEvent = {
      target: {
        ...e.target,
        value: numericValue,
        name: e.target.name
      }
    };
    handleChange(syntheticEvent);
  };

  const handleIdChange = (e) => {
    const value = e.target.value;
    // Remove any non-numeric characters
    const numericValue = value.replace(/\D/g, '');
    validateIdNumber(numericValue);
    
    // Create synthetic event with the cleaned value
    const syntheticEvent = {
      target: {
        ...e.target,
        value: numericValue,
        name: e.target.name
      }
    };
    handleChange(syntheticEvent);
  };
  return (
    <>
      <Passenger>
        {roundTrip ? (
          <label htmlFor={`rname${passengerIndex ? passengerIndex : ""}`}>
            Passenger {passengerIndex}
          </label>
        ) : (
          <label htmlFor={`name${passengerIndex ? passengerIndex : ""}`}>
            Passenger {passengerIndex}
          </label>
        )}

        {roundTrip ? (
          <UserContactWrapper>
            <FirstNameAndNid>

              <TextField
                id={`first${passengerIndex}`}
                name={`first${passengerIndex}`}
                type="text"
                placeholder="First Name"
                value={values[`first${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </FirstNameAndNid>
            <TextField
              type="text"
              placeholder="Surname"
              name={`rsurName${passengerIndex}`}
              value={values[`rsurName${passengerIndex}`]}
              onChange={handleChange}
              autoComplete="nope"
            />
          </UserContactWrapper>
        ) : (
          <UserContactWrapper>
            <FirstNameAndNid>

              <TextField
                id={`first${passengerIndex}`}
                name={`first${passengerIndex}`}
                type="text"
                placeholder="First Name"
                value={values[`first${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </FirstNameAndNid>
            <TextField
              type="text"
              placeholder="Surname"
              name={`second${passengerIndex}`}
              value={values[`second${passengerIndex}`]}
              onChange={handleChange}
              autoComplete="nope"
            />
          </UserContactWrapper>
        )}
      </Passenger>
      {/* end passenger */}

      {roundTrip ? (
        <Passenger>
          <label htmlFor={`rnid${passengerIndex ? passengerIndex : ""}`}>
            National ID <samp style={{ color: 'red' }}><b>*</b></samp>
          </label>
          <UserContactWrapper>
            {/* start */}
            <FirstNameAndNid>
              <TextField
                id={`rnid${passengerIndex ? passengerIndex : ""}`}
                name={`renid${passengerIndex}`}
                type="tel"
                placeholder="National ID number"
                value={values[`renid${passengerIndex}`]}
                onChange={handleIdChange}
                onKeyPress={(e) => {
                  // Only allow numeric keys
                  const char = String.fromCharCode(e.which);
                  if (!/[\d]/.test(char)) {
                    e.preventDefault();
                  }
                }}
              />
              {idError && (
                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                  {idError}
                </div>
              )}
            </FirstNameAndNid>

            <TextField
              type="tel"
              placeholder="07XXXXXXXX"
              name={`contactNo${passengerIndex}`}
              maxLength="10"
              value={values[`contactNo${passengerIndex}`]}
              onChange={handleContactChange}
              onKeyPress={(e) => {
                // Only allow numeric keys
                const char = String.fromCharCode(e.which);
                if (!/[\d]/.test(char)) {
                  e.preventDefault();
                }
              }}
              autoComplete="nope"
            />
            {contactError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                {contactError}
              </div>
            )}
          </UserContactWrapper>
        </Passenger>
      ) : (
        <Passenger>
          <label htmlFor={`nid${passengerIndex ? passengerIndex : ""}`}>
            National ID <samp style={{ color: 'red' }}><b>*</b></samp>
          </label>
          <UserContactWrapper>
            {/* start */}
            <FirstNameAndNid>
              <TextField
                id={`nid${passengerIndex ? passengerIndex : ""}`}
                name={`renid${passengerIndex}`}
                type="tel"
                placeholder="National ID number"
                value={values[`renid${passengerIndex}`]}
                onChange={handleIdChange}
                onKeyPress={(e) => {
                  // Only allow numeric keys
                  const char = String.fromCharCode(e.which);
                  if (!/[\d]/.test(char)) {
                    e.preventDefault();
                  }
                }}
              />
              {idError && (
                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                  {idError}
                </div>
              )}
            </FirstNameAndNid>

            <TextField
              type="tel"
              placeholder="07XXXXXXXX"
              name={`contactNo${passengerIndex}`}
              maxLength="10"
              value={values[`contactNo${passengerIndex}`]}
              onChange={handleContactChange}
              onKeyPress={(e) => {
                // Only allow numeric keys
                const char = String.fromCharCode(e.which);
                if (!/[\d]/.test(char)) {
                  e.preventDefault();
                }
              }}
              autoComplete="nope"
            />
            {contactError && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                {contactError}
              </div>
            )}
          </UserContactWrapper>
        </Passenger>
      )}
    </>
  );
};

export default SingleTravellerInformation;
